
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAudioOutput as ObcAudioOutputElement} from '@oicl/openbridge-webcomponents/dist/components/audio-output/audio-output.js';
 
 
 

 
 export const ObcAudioOutput = createComponent({
   react: React,
   tagName: 'obc-audio-output',
   elementClass: ObcAudioOutputElement,
   events: {
     
   }
  });
 
 